import { render } from "./ReportSummary2.vue?vue&type=template&id=641c7202"
import script from "./ReportSummary2.vue?vue&type=script&lang=js"
export * from "./ReportSummary2.vue?vue&type=script&lang=js"

import "./ReportSummary2.vue?vue&type=style&index=0&id=641c7202&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__